import { createContext, useContext } from "react";
export const MarkdownStyleContext = createContext({
    textColor: "s-text-foreground dark:s-text-foreground-night",
    compactSpacing: false,
    canCopyQuotes: true,
});
export function useMarkdownStyle() {
    return useContext(MarkdownStyleContext);
}
//# sourceMappingURL=MarkdownStyleContext.js.map